<template>
    <modal :close="close" class="modal" printButton downloadButton :printStyle="printStyle" :title="title">
        <h3 slot="modalHeader" class="modal__header">
            <i class="uk-icon-users"></i>
            Сообщения эмитента
        </h3>
        <div slot="modalBody" class="modal__content">
            <loading v-if="isLoading" />
            <issuer-not-found v-if="!isLoading && !list.length" />
            <ul class="list" v-if="!isLoading && list.length">
                <li class="list__item" v-for="(e,i) in list" :key="i">
                    <app-accordion>
                        <p class="title" slot="title">
                            <b class="title__date" v-if="e.date_event">{{dateParser(e.date_event)}}</b>
                            <span class="title__name" v-if="e.name_event">{{e.name_event}}</span>
                        </p>
                        <div slot="content">
                            <pre class="text" v-if="e.text_event">{{e.text_event}}</pre>
                            <pre class="text no_print" v-else>Не удалось загрузить текст. Попробуйте загрузить позже.</pre>
                        </div>
                    </app-accordion>
                </li>
            </ul>
        </div>
        <div slot="modalFooter" class="modal__footer">
            <old-pagination
                v-if="pagination && pagination.rows_count > 25"
                :paginationObj="pagination"
                :getNewContent="changePage" 
            />
        </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import loading from '@/components/ui/loading/loading.vue'
import oldPagination from '@/components/ui/oldPagination/oldPagination.vue'
import issuerNotFound from '@/components/card/shortResume/issuerMessage/issuerNotFound.vue'
import appAccordion from '@/components/ui/appAccordion/appAccordion.vue'

export default {
    props: {
        ogrn: {
            type: Number,
            default: 0
        }
    },
    components: {
        modal,
        loading,
        oldPagination,
        issuerNotFound,
        appAccordion
    },
    data: () => ({
        printStyle: `
            .accordion { padding: 15px; border-bottom: 1px solid #a0a0a0; }
            .accordion__btn { border: none; background: none; }
            .accordion__btn p.title { font-size: 16px; color: #074c92; }
            .accordion__content { display: block !important; }
            pre.text { white-space: pre-line; font: inherit; background: none; border: none; margin: 0; padding: 0; }
        `
    }),
    computed: {
        isLoading() { return this.$store.state.card?.shortResume?.issuer?.isLoading },
        pagination() { return this.$store.state.card?.shortResume?.issuer?.pagination },
        list() { return this.$store.state.card?.shortResume?.issuer?.list },
        companyName() { return this.$store.state.card?.company?.name_short || this.$store.state.card?.company?.name_full },
        title() { return `Сообщения эмитента | ${this.companyName}` }
    },
    methods: {
        close() { this.$emit('close') },
        changePage(limit, offset) {
            this.$store.dispatch('card/shortResume/issuer/getData', {
                ogrn: this.$props.ogrn,
                limit,
                offset
            })
        } 
    }
}
</script>

<style lang="sass" scoped>
.modal
    &__header
        border: none !important
        font-size: 24px !important
        font-weight: 400 !important
        color: #444 !important
    &__content
        .list
            padding: 15px
            &__item
                margin-bottom: 15px
                .text
                    white-space: pre-line
                    padding: 10px
                    background: #fafafa
                    font: 12px/18px Consolas,monospace,serif
                    tab-size: 4
                    border: 1px solid #ddd
                    border-radius: 3px
                    margin: 0
                .title
                    text-align: left
                        
    &__footer
        width: 50%
        float: left
        display: flex
        justify-content: flex-start
</style>